import DynamicPage from "./dynamic"

export default DynamicPage
